import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

// Defer native detection to runtime to avoid race conditions on iOS
export const isNative = () => {
  try {
    return Capacitor.isNativePlatform?.() === true;
  } catch (error) {
    console.warn('Native platform detection failed:', error);
    return false;
  }
};

export const nativeStorageAdapter = {
  getItem: async (key: string) => {
    const { value } = await Preferences.get({ key });
    return value ?? null;
  },
  setItem: async (key: string, value: string) => {
    await Preferences.set({ key, value });
  },
  removeItem: async (key: string) => {
    await Preferences.remove({ key });
  },
} as const;